module.exports = __webpack_public_path__ + "files/SPIADI2026 - Annexe Codage disciplines et spécialités.730089f91916f02215a10d28b71366fd.pdf";